import React, { useState, useEffect } from 'react';
import { Typography, Button } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import DialogInput, { DialogInputConsumer } from 'components/dialog/DialogInput';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { setSchedule } from 'store/redux/modules/order/actions';
import { addMinutes, format } from 'date-fns';
import CustomTimerPicker from 'components/pickers/TimerPicker';
import { ptBR } from 'date-fns/locale';

const useStyles = makeStyles(theme => ({
  actions: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    textAlign: 'center',
  },
  total: {
    fontWeight: 500,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    flex: 1,
  },
}));

ShipmentCollectSchedule.propTypes = {
  onExited: PropTypes.func.isRequired,
};

export default function ShipmentCollectSchedule({ onExited }) {
  const restaurant = useSelector(state => state.restaurant);
  const order = useSelector(state => state.order);
  const [hasSchedule, setHasSchedule] = useState(false);
  const dispatch = useDispatch();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [scheduledAt, setScheduledAt] = useState(
    order.shipment.scheduled_at
      ? order.shipment.scheduled_at
      : addMinutes(currentTime, restaurant.configs.delivery_time)
  );
  const classes = useStyles();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  function handleScheduleYes() {
    setHasSchedule(true);
  }

  function handleScheduleNo() {
    setHasSchedule(false);
    dispatch(setSchedule(null));
  }

  function handleSubmit(event, handleCloseDialog) {
    event.preventDefault();
    dispatch(setSchedule(scheduledAt));
    handleCloseDialog();
  }

  return (
    <DialogInput onExited={onExited} maxWidth="sm">
      <DialogInputConsumer>
        {({ handleCloseDialog }) => (
          <>
            {!hasSchedule ? (
              <div className={classes.container}>
                <Typography variant="h6">Agendar a retirada?</Typography>
                <div className={classes.actions}>
                  <Button
                    onClick={() => {
                      handleScheduleNo();
                      handleCloseDialog();
                    }}
                    variant="text"
                    color="primary"
                  >
                    Não
                  </Button>
                  <Button onClick={handleScheduleYes} variant="contained" color="primary">
                    Sim
                  </Button>
                </div>
              </div>
            ) : (
              <div className={classes.container}>
                <form onSubmit={event => handleSubmit(event, handleCloseDialog)} className={classes.form}>
                  <Typography>Escolha a hora em que deseja retirar seu pedido</Typography>
                  <CustomTimerPicker
                    hideBackdrop
                    value={scheduledAt}
                    handleDateChange={date => setScheduledAt(date)}
                    label="Horário da retirada"
                    helperText={`Horário sugerido ${format(
                      addMinutes(currentTime, restaurant.configs.delivery_time),
                      'HH:mm:ss',
                      {
                        locale: ptBR,
                      }
                    )}`}
                  />

                  <div className={classes.actions}>
                    <Button onClick={() => setHasSchedule(false)} type="button" color="primary" variant="text">
                      voltar
                    </Button>
                    <Button type="submit" color="primary" variant="contained">
                      Confirmar
                    </Button>
                  </div>
                </form>
              </div>
            )}
          </>
        )}
      </DialogInputConsumer>
    </DialogInput>
  );
}
